export default __webpack_public_path__ + "static/media/MySQL.c2bdae86.jpg";